// Versione "lite" di TournamentCard / SearchComponent / WrappedPrematchTournamentPage
// per la home di gojjobet. Logica da awrabet, template lite.
import {h, Fragment, Component} from "preact";

import PFeed from "../../../services/prematch-feed";
import SchedulesTimeFilter from "../../jamibet/utils/schedules-time-filter.jsx";
import * as I from "../../jamibet/utils/icons.jsx";
import * as D from "../../jamibet/desktop-templates/prematch-menu.jsx";

import * as P from "./templates-sports.jsx";
import * as T from "./templates-tournament.jsx";
import { MobileEvent } from "./mobile-event.jsx";

import {
	SearchComponent as AwrabetSearchComponent,
	WrappedPrematchTournamentPage as AwrabetWrappedPrematchTournamentPage,
	TournamentCard as AwrabetTournamentCard
} from "../../awrabet/mobile-pages/prematch.jsx";

export class SearchComponent extends AwrabetSearchComponent {
	render() {
		return <P.SearchBar
				   onInput={e => this.performEventSearch(e.target.value)}
				   open={!!this.state.content}
				   value={this.state.content}
				   onClick={e => this.setupEvents()}
				   ref={ref => this.rootNode = ref && ref.base}>
			<P.SearchContentWrapper>
				<P.SearchPopupContainer>
					<P.SearchPopupHeader>
						<P.SearchPopupLabel>Search Results ({this.state.results.length})</P.SearchPopupLabel>
						<P.SearchPopupClose onClick={e => this.closePopup()}><I.CloseIconSlim class="h-5" /></P.SearchPopupClose>
					</P.SearchPopupHeader>
					<P.SearchPopupEventsHolder>
						{this.state.results.map(({event, sport, category, tournament}) => (
							<P.SearchEventRow onClick={e => this.openEvent(event)}>
								<P.SearchEventName>{event.home} - {event.away}</P.SearchEventName>
								<P.SearchEventInfoRow>
									<P.SearchEventFlag><D.RegionFlagIcon category={category} /></P.SearchEventFlag>
									<P.SearchEventTournamentName>{sport.name} / {category.name} / {tournament.name}</P.SearchEventTournamentName>
									<P.SearchEventSeparator />
									<P.SearchEventSportFlag>
										<P.SportIconSmall sport={sport} />
									</P.SearchEventSportFlag>
								</P.SearchEventInfoRow>
							</P.SearchEventRow>
						))}
					</P.SearchPopupEventsHolder>
				</P.SearchPopupContainer>
			</P.SearchContentWrapper>
		</P.SearchBar>
	}
}

export class WrappedPrematchTournamentPage extends AwrabetWrappedPrematchTournamentPage {
	render({tournamentId, children}) {
		if (!this.state.tournamentCard)
			return null;

		return children({tournament: this.state.tournamentCard})
	}
}

export class TournamentCard extends AwrabetTournamentCard {
	render({tournamentCard, minEvents = undefined}) {
		const {giornateSorted, displayRuleFiltered} = this.state;

		let uglyMatchlimit = minEvents || Infinity;

		return giornateSorted.filter(s => SchedulesTimeFilter.isEventAllowed(s[0])).map(eventsList => {
			if (uglyMatchlimit <= 0)
				return null;

			const matches = eventsList
				.filter(s => SchedulesTimeFilter.isEventAllowed(s))
				.slice(0, uglyMatchlimit);

			uglyMatchlimit -= matches.length;

			return <Fragment>
				<T.TournamentDatesHeader>
					<T.TournamentDate>{this.getLocalEventDate(eventsList[0])}</T.TournamentDate>
					{displayRuleFiltered.map(outcome => <T.OutcomeNameHeader>{outcome.name}</T.OutcomeNameHeader>)}
				</T.TournamentDatesHeader>
				{matches.map(event => {
					const {tournament} = PFeed.getWithParents(event.id);
					return <MobileEvent {...{tournament, event, displayRuleFiltered, tournamentCard}} />
				})}
			</Fragment>;
		})
	}
}
